export default function Logo({ className = "" }) {
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className={`inline-flex items-center ${className}`}
      aria-label="Vish Capital — Finance Simplified"
    >
      <img
        src="/assets/vish-logo.png"
        alt="Vish Capital"
        className="h-10 md:h-12 w-auto object-contain"
      />
    </a>
  );
}
